export default __webpack_public_path__ + "static/media/quickcam-speed-ramp-v2.52982b37.png";